import React from 'react';

// Routes
import Routes from './content-modules-routes';

export default function (props) {

  return (
   <div>
       <Routes />
   </div>
  )
}
